export const postMessageFn = (event: string, isEventWeb?: boolean) => {
  console.log(event); // NO BORRAR
  if (typeof window !== "undefined") {
    if (window.MessageInvoker) {
      window.MessageInvoker.postMessage(event);
    } else {
      window.parent.postMessage(event, "*");
    }
  }

  if (isEventWeb) {
    if (window.messageHandler || parent.messageHandler) {
      const element = window.messageHandler || parent.messageHandler;
      element.postMessage(event);
    }
  }
};
